var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, when, makeObservable } from 'mobx';
export class AnswerPrepare {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get answer() {
        return this.parent;
    }
    get app() {
        return this.answer.app;
    }
    get isPrepared() {
        // bugy when used in when context
        const question = this.answer.streamedQuestion;
        if (!question) {
            return false;
        }
        if (!question.questionPrepare.areRequiredResourcesLoaded) {
            console.log(`prepared answer [${this.answer.id} (${this.answer.question_id})]`);
            return false;
        }
        return true;
    }
    async prepareAnswer() {
        await when(() => !!this.answer.streamedQuestion);
        await this.answer.solidQuestion.questionPrepare.loadRequiredResources();
        console.log(`prepared answer [${this.answer.id} (${this.answer.question_id})]`);
    }
}
__decorate([
    computed
], AnswerPrepare.prototype, "isPrepared", null);
